<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2 class="font-bold">能耗</h2>
      </div>
      <div class="cable-main">
        <!-- <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div> -->
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="1#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main1"></router-link>
          </el-tooltip>
          <div class="stati sta-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_sensor("当量相对湿度", humidityTooltipErrorDehumidifierEquivalentLeft, humidityAllowedMaxDehumidifierEquivalentLeft)
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "相对湿度",
                    humidityTooltipErrorDehumidifierLeft,
                    humidityAllowedMaxDehumidifierLeft,
                    runningDehumidifierLeft,
                    malfunctionDehumidifierLeft
                  )
                }}
              </div>
              <div :class="errorDehumidifierLeft" class="state-info bottom-pos" @dblclick="hrefToStation('/station/main1')">
                <p>1#空气制备站送风</p>
                <p>
                  <span
                    >当量: {{ humidityDehumidifierEquivalentLeft | toFixed }}% <br />
                    {{ humidityDehumidifierLeft | toFixed }}% {{ temperatureDehumidifierLeft | toFixed }}°C</span
                  >
                  <span :class="runningClassLeft" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-power-left-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                1#空气制备站
                <br />
                {{ assembleTooltip_groupKeyValue("功率", ["P"], [powerStationMainLeftTotal], ["kW"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("总电能", ["EC"], [energyStationMainLeftTotal], ["kW·h"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("昨日电能", ["EC"], [energyStationMainLeftYesterday], ["kW·h"]) }}
              </div>
              <div :class="errorPowerMainLeftPowerEnergy" class="state-info right-pos" @dblclick="hrefToStation('/station/main1')">
                <p>
                  <span class="bold">1#空气制备站</span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerStationMainLeftTotal | toFixed }}kW </span>
                </p>
                <p>
                  <span>总电能</span>
                  <span>{{ energyStationMainLeftTotal | toFixed }}kW·h </span>
                </p>
                <p>
                  <span>昨日</span>
                  <span>{{ energyStationMainLeftYesterday | toFixed }}kW·h </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-power-left-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                1#空气制备站
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["Va", "Vb", "Vc"],
                    [voltageStationMainLeftA, voltageStationMainLeftB, voltageStationMainLeftC],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentStationMainLeftA, currentStationMainLeftB, currentStationMainLeftC],
                    ["A", "A", "A"]
                  )
                }}
              </div>
              <div :class="errorPowerMainLeftVoltageCurrent" class="state-info left-pos" @dblclick="hrefToStation('/station/main1')">
                <p>
                  <span class="bold">1#空气制备站</span>
                </p>
                <p>
                  <span>电压</span>
                  <span
                    >{{ voltageStationMainLeftA | toFixed }}V | {{ voltageStationMainLeftB | toFixed }}V |
                    {{ voltageStationMainLeftC | toFixed }}V</span
                  >
                </p>
                <p>
                  <span>电流</span>
                  <span
                    >{{ currentStationMainLeftA | toFixed }}A | {{ currentStationMainLeftB | toFixed }}A | {{ currentStationMainLeftC | toFixed }}A
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="2#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main2"></router-link>
          </el-tooltip>
          <div class="stati sta-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_sensor(
                    "当量相对湿度",
                    humidityTooltipErrorDehumidifierEquivalentRight,
                    humidityAllowedMaxDehumidifierEquivalentRight
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "相对湿度",
                    humidityTooltipErrorDehumidifierRight,
                    humidityAllowedMaxDehumidifierRight,
                    runningDehumidifierRight,
                    malfunctionDehumidifierRight
                  )
                }}
              </div>
              <div :class="errorDehumidifierRight" class="state-info bottom-pos" @dblclick="hrefToStation('/station/main2')">
                <p>2#空气制备站送风</p>
                <p>
                  <span
                    >当量: {{ humidityDehumidifierEquivalentRight | toFixed }}% <br />
                    {{ humidityDehumidifierRight | toFixed }}% {{ temperatureDehumidifierRight | toFixed }}°C</span
                  >
                  <span :class="runningClassRight" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-power-right-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                2#空气制备站
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["Va", "Vb", "Vc"],
                    [voltageStationMainRightA, voltageStationMainRightB, voltageStationMainRightC],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentStationMainRightA, currentStationMainRightB, currentStationMainRightC],
                    ["A", "A", "A"]
                  )
                }}
              </div>
              <div :class="errorPowerMainRightVoltageCurrent" class="state-info right-pos" @dblclick="hrefToStation('/station/main2')">
                <p>
                  <span class="bold">2#空气制备站</span>
                </p>
                <p>
                  <span>电压</span>
                  <span
                    >{{ voltageStationMainRightA | toFixed }}V | {{ voltageStationMainRightB | toFixed }}V |
                    {{ voltageStationMainRightC | toFixed }}V</span
                  >
                </p>
                <p>
                  <span>电流</span>
                  <span
                    >{{ currentStationMainRightA | toFixed }}A | {{ currentStationMainRightB | toFixed }}A | {{ currentStationMainRightC | toFixed }}A
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-power-right-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                2#空气制备站
                <br />
                {{ assembleTooltip_groupKeyValue("功率", ["P"], [powerStationMainRightTotal], ["kW"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("总电能", ["EC"], [energyStationMainRightTotal], ["kW·h"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("昨日电能", ["EC"], [energyStationMainRightYesterday], ["kW·h"]) }}
              </div>
              <div :class="errorPowerMainRightPowerEnergy" class="state-info left-pos" @dblclick="hrefToStation('/station/main1')">
                <p>
                  <span class="bold">2#空气制备站</span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerStationMainRightTotal | toFixed }}kW </span>
                </p>
                <p>
                  <span>总电能</span>
                  <span>{{ energyStationMainRightTotal | toFixed }}kW·h </span>
                </p>
                <p>
                  <span>昨日</span>
                  <span>{{ energyStationMainRightYesterday | toFixed }}kW·h </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>能耗</h2>
      </div>
      <div class="cable-main">
        <!-- <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div> -->
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>备用机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="1#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main1"></router-link>
          </el-tooltip>
          <div class="stati sta-power-left-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                1#空气制备站(备机)
                <br />
                {{ assembleTooltip_groupKeyValue("功率", ["P"], [powerStationBackupLeftTotal], ["kW"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("总电能", ["EC"], [energyStationBackupLeftTotal], ["kW·h"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("昨日电能", ["EC"], [energyStationBackupLeftYesterday], ["kW·h"]) }}
              </div>
              <div :class="errorPowerBackupLeftPowerEnergy" class="state-info right-pos" @dblclick="hrefToStation('/station/main1')">
                <p>
                  <span class="bold">1#空气制备站(备机)</span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerStationBackupLeftTotal | toFixed }}kW</span>
                </p>
                <p>
                  <span>总电能</span>
                  <span>{{ energyStationBackupLeftTotal | toFixed }}kW·h</span>
                </p>
                <p>
                  <span>昨日</span>
                  <span>{{ energyStationBackupLeftYesterday | toFixed }}kW·h </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-power-left-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                1#空气制备站(备机)
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["Va", "Vb", "Vc"],
                    [voltageStationBackupLeftA, voltageStationBackupLeftB, voltageStationBackupLeftC],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentStationBackupLeftA, currentStationBackupLeftB, currentStationBackupLeftC],
                    ["A", "A", "A"]
                  )
                }}
              </div>
              <div :class="errorPowerBackupLeftVoltageCurrent" class="state-info left-pos" @dblclick="hrefToStation('/station/main1')">
                <p>
                  <span class="bold">1#空气制备站(备机)</span>
                </p>
                <p>
                  <span>电压</span>
                  <span
                    >{{ voltageStationBackupLeftA | toFixed }}V | {{ voltageStationBackupLeftB | toFixed }}V |
                    {{ voltageStationBackupLeftC | toFixed }}V</span
                  >
                </p>
                <p>
                  <span>电流</span>
                  <span
                    >{{ currentStationBackupLeftA | toFixed }}A | {{ currentStationBackupLeftB | toFixed }}A |
                    {{ currentStationBackupLeftC | toFixed }}A
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="2#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main2"></router-link>
          </el-tooltip>
          <div class="stati sta-power-right-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                2#空气制备站(备机)
                <br />
                {{ assembleTooltip_groupKeyValue("功率", ["P"], [powerStationBackupRightTotal], ["kW"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("总电能", ["EC"], [energyStationBackupRightTotal], ["kW·h"]) }}
                <br />
                {{ assembleTooltip_groupKeyValue("昨日电能", ["EC"], [energyStationBackupRightYesterday], ["kW·h"]) }}
              </div>
              <div :class="errorPowerBackupRightPowerEnergy" class="state-info left-pos" @dblclick="hrefToStation('/station/main2')">
                <p>
                  <span class="bold">2#空气制备站(备机)</span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerStationBackupRightTotal | toFixed }}kW</span>
                </p>
                <p>
                  <span>总电能</span>
                  <span>{{ energyStationBackupRightTotal | toFixed }}kW·h</span>
                </p>
                <p>
                  <span>昨日</span>
                  <span>{{ energyStationBackupRightYesterday | toFixed }}kW·h </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-power-right-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                2#空气制备站(备机)
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["Va", "Vb", "Vc"],
                    [voltageStationBackupRightA, voltageStationBackupRightB, voltageStationBackupRightC],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentStationBackupRightA, currentStationBackupRightB, currentStationBackupRightC],
                    ["A", "A", "A"]
                  )
                }}
              </div>
              <div :class="errorPowerBackupRightVoltageCurrent" class="state-info right-pos" @dblclick="hrefToStation('/station/main2')">
                <p>
                  <span class="bold">2#空气制备站(备机)</span>
                </p>
                <p>
                  <span>电压</span>
                  <span
                    >{{ voltageStationBackupRightA | toFixed }}V | {{ voltageStationBackupRightB | toFixed }}V |
                    {{ voltageStationBackupRightC | toFixed }}V</span
                  >
                </p>
                <p>
                  <span>电流</span>
                  <span
                    >{{ currentStationBackupRightA | toFixed }}A | {{ currentStationBackupRightB | toFixed }}A |
                    {{ currentStationBackupRightC | toFixed }}A
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenSensor",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //humidity, temperature
      voltageStationMainLeftA: "--",
      voltageStationMainLeftB: "--",
      voltageStationMainLeftC: "--",
      currentStationMainLeftA: "--",
      currentStationMainLeftB: "--",
      currentStationMainLeftC: "--",
      powerStationMainLeftA: "--",
      powerStationMainLeftB: "--",
      powerStationMainLeftC: "--",
      powerStationMainLeftTotal: "--",
      energyStationMainLeftA: "--",
      energyStationMainLeftB: "--",
      energyStationMainLeftC: "--",
      energyStationMainLeftTotal: "--",
      energyStationMainLeftYesterday: "--",
      voltageStationBackupLeftA: "--",
      voltageStationBackupLeftB: "--",
      voltageStationBackupLeftC: "--",
      currentStationBackupLeftA: "--",
      currentStationBackupLeftB: "--",
      currentStationBackupLeftC: "--",
      powerStationBackupLeftA: "--",
      powerStationBackupLeftB: "--",
      powerStationBackupLeftC: "--",
      powerStationBackupLeftTotal: "--",
      energyStationBackupLeftA: "--",
      energyStationBackupLeftB: "--",
      energyStationBackupLeftC: "--",
      energyStationBackupLeftTotal: "--",
      energyStationBackupLeftYesterday: "--",

      voltageStationMainRightA: "--",
      voltageStationMainRightB: "--",
      voltageStationMainRightC: "--",
      currentStationMainRightA: "--",
      currentStationMainRightB: "--",
      currentStationMainRightC: "--",
      powerStationMainRightA: "--",
      powerStationMainRightB: "--",
      powerStationMainRightC: "--",
      powerStationMainRightTotal: "--",
      energyStationMainRightA: "--",
      energyStationMainRightB: "--",
      energyStationMainRightC: "--",
      energyStationMainRightTotal: "--",
      energyStationMainRightYesterday: "--",
      voltageStationBackupRightA: "--",
      voltageStationBackupRightB: "--",
      voltageStationBackupRightC: "--",
      currentStationBackupRightA: "--",
      currentStationBackupRightB: "--",
      currentStationBackupRightC: "--",
      powerStationBackupRightA: "--",
      powerStationBackupRightB: "--",
      powerStationBackupRightC: "--",
      powerStationBackupRightTotal: "--",
      energyStationBackupRightA: "--",
      energyStationBackupRightB: "--",
      energyStationBackupRightC: "--",
      energyStationBackupRightTotal: "--",
      energyStationBackupRightYesterday: "--",

      humidityDehumidifierLeft: "--",
      humidityDehumidifierRight: "--",
      humidityDehumidifierEquivalentLeft: "--",
      humidityDehumidifierEquivalentRight: "--",

      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierRight: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierRight: "--",

      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorDehumidifierLeft: "--",
      errorDehumidifierRight: "--",
      errorPowerMainLeftVoltageCurrent: "--",
      errorPowerMainLeftPowerEnergy: "--",
      errorPowerBackupLeftVoltageCurrent: "--",
      errorPowerBackupLeftPowerEnergy: "--",
      errorPowerMainRightVoltageCurrent: "--",
      errorPowerMainRightPowerEnergy: "--",
      errorPowerBackupRightVoltageCurrent: "--",
      errorPowerBackupRightPowerEnergy: "--",

      //running class
      runningClassLeft: "--",
      runningClassRight: "--",

      //humidity allowed max
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierRight: "--",
      humidityAllowedMaxDehumidifierEquivalentLeft: "--",
      humidityAllowedMaxDehumidifierEquivalentRight: "--",

      //humidity tooltip error
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierRight: "--",
      humidityTooltipErrorDehumidifierEquivalentLeft: "--",
      humidityTooltipErrorDehumidifierEquivalentRight: "--",

      dataNameIdDict: {
        //humidity, temperature
        voltageStationMainLeftA: "b871730e-a303-4816-ae8f-adcf48c83692",
        voltageStationMainLeftB: "56a6bbaf-c81e-4752-a359-f040fbce20ad",
        voltageStationMainLeftC: "91203bc1-f06b-4264-a18e-dc8c9562c4a2",
        currentStationMainLeftA: "37ef544c-af02-42b1-9b47-1b3d0a7c9939",
        currentStationMainLeftB: "b864a741-b38b-4a0a-be98-311ff8d8f872",
        currentStationMainLeftC: "e7d2d89c-a33c-4f1c-9738-fb2875d82ee3",
        powerStationMainLeftA: "3a929160-c69c-4295-b79f-5f4775de2283",
        powerStationMainLeftB: "4ccbb54a-d2dd-42af-80c9-debe6c0bb468",
        powerStationMainLeftC: "c953216e-d47b-4918-be17-d8452fa0c3a7",
        powerStationMainLeftTotal: "9364bf5e-4cb9-41a5-8812-4538363342e4",
        energyStationMainLeftA: "0fe0273b-d448-4694-945a-6f1d6f0d81de",
        energyStationMainLeftB: "22cbb35b-1505-4d4b-817f-76ccf7d6ffdc",
        energyStationMainLeftC: "248fd72f-604d-4672-951c-897b9ccdc4f8",
        energyStationMainLeftTotal: "db76ccb1-802b-47cd-9930-27eb57b6bd74",
        voltageStationBackupLeftA: "383b2d55-d7f1-41ca-ba84-ad59a0296dfd",
        voltageStationBackupLeftB: "83731d6e-33bf-4e4a-ba37-230c579ff8e2",
        voltageStationBackupLeftC: "fbfc5132-67fa-4a44-9970-4be8024b5193",
        currentStationBackupLeftA: "cafa3225-0ce6-424a-8d81-85387d11ad06",
        currentStationBackupLeftB: "6726b2e6-1754-4189-b45f-5cea8377d264",
        currentStationBackupLeftC: "24187630-d45c-472d-a23a-62ba1d189bbd",
        powerStationBackupLeftA: "d308aa63-da9c-4a3d-a583-64920f75ea87",
        powerStationBackupLeftB: "2b851dca-94d2-4a15-b6f8-a0dfcc2c9ce3",
        powerStationBackupLeftC: "b0379343-7cec-47c9-929c-eba44b2dc109",
        powerStationBackupLeftTotal: "83d354a8-ff82-474f-9360-1f7579ed77a2",
        energyStationBackupLeftA: "00f9292e-76b5-4618-8c3a-c799e01e4b9b",
        energyStationBackupLeftB: "45b5a81b-565e-4c87-a889-ee3c4acd5e04",
        energyStationBackupLeftC: "eda71957-f42b-48f9-af64-dbfa06aa9953",
        energyStationBackupLeftTotal: "9cf45983-47fd-4931-976f-6cf88212264f",

        voltageStationMainRightA: "cec6c64f-f7fa-4008-a3c3-84e4166d77f7",
        voltageStationMainRightB: "443c74b8-fbb6-4f7e-a22d-2b507d8055fe",
        voltageStationMainRightC: "ff1df774-ce16-4437-aaba-3bd2c0da2da5",
        currentStationMainRightA: "9f48bd13-31f9-41e7-8fcd-82fc779dc90d",
        currentStationMainRightB: "527e9f1b-08df-4439-b3f5-7dfc9206a21f",
        currentStationMainRightC: "9e08a477-8605-4dd2-9730-48537f0695c0",
        powerStationMainRightA: "5fee38d2-587a-4de5-8dcc-d13c8e34b625",
        powerStationMainRightB: "aa2caea2-063a-4e54-ad5f-72a4eca8f546",
        powerStationMainRightC: "e3351f40-554d-4bfc-83ed-e6a32227e30e",
        powerStationMainRightTotal: "a26c5021-f1da-4ac2-b18a-cc48d8fc9d7c",
        energyStationMainRightA: "7676fe83-ef14-471c-a7ca-7bba3e0c483a",
        energyStationMainRightB: "1d86e9d7-32ec-4a4a-9e28-f33a0c87227a",
        energyStationMainRightC: "9ace77c4-a13f-4aea-b368-f888e8e2726e",
        energyStationMainRightTotal: "17cd8e3e-6db8-493a-8c91-3776b46667b5",
        voltageStationBackupRightA: "8a78c904-8b7b-4be2-8204-0f672d08c0e3",
        voltageStationBackupRightB: "c55b03d5-ab71-4a6f-9480-8b6efedb361c",
        voltageStationBackupRightC: "b6784759-a2d5-4d74-b12e-8ca64234ae4f",
        currentStationBackupRightA: "dc9f156c-546f-444e-879d-6ff7e54f4c2b",
        currentStationBackupRightB: "eb41b8e0-f6c4-4891-aa24-48bed9c608b8",
        currentStationBackupRightC: "425c0ce7-6a1a-4ab6-a1af-9f53401e80fa",
        powerStationBackupRightA: "3daf419e-4aeb-471f-91ba-38c7d5cad4bd",
        powerStationBackupRightB: "532240a7-2512-4286-ada6-4f5bd3506bc8",
        powerStationBackupRightC: "1451a14d-625b-4bc9-a0bb-0ffee298483b",
        powerStationBackupRightTotal: "b52249ff-1567-4960-ba7e-d44773c97ef6",
        energyStationBackupRightA: "ed9af6d9-fde3-4082-b868-2ac3964df6c1",
        energyStationBackupRightB: "7ab82195-828e-429f-8a12-0e17bcbd8259",
        energyStationBackupRightC: "a8a59fa1-df60-41a1-8eb9-be7c0abf84c5",
        energyStationBackupRightTotal: "c3912fad-2df9-425c-9a86-a7162efd1d64",

        humidityDehumidifierLeft: "ea50a278-9f53-4aaf-bf2c-bb7c576a8308",
        humidityDehumidifierRight: "a7f05749-e227-4021-b390-928934fe5fea",
        humidityDehumidifierEquivalentLeft: "c0d81c98-c485-4795-8f3f-87a2b3acd516",
        humidityDehumidifierEquivalentRight: "03e55848-49d7-4551-9d05-f6dd9bd2a0cd",

        temperatureDehumidifierLeft: "cda32056-67de-4c68-ad29-6f6768497c78",
        temperatureDehumidifierRight: "c9428902-4cc1-4dc5-ba5b-bfa94381f6b3",

        //running
        runningDehumidifierLeft: "79b4e6f9-6127-4bac-8af7-0e2d4721c5d2",
        runningDehumidifierRight: "e914cf14-f4cc-4fb7-b475-a2d452286f9f",

        //malfunction
        malfunctionDehumidifierLeft: "31a3d703-8d99-4712-8a32-dcfe31086179",
        malfunctionDehumidifierRight: "23ae5bfb-b57c-46dd-a23e-c5ffdd955720",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxDehumidifierLeft: "ea50a278-9f53-4aaf-bf2c-bb7c576a8308",
        humidityAllowedMaxDehumidifierRight: "a7f05749-e227-4021-b390-928934fe5fea",
        humidityAllowedMaxDehumidifierEquivalentLeft: "c0d81c98-c485-4795-8f3f-87a2b3acd516",
        humidityAllowedMaxDehumidifierEquivalentRight: "03e55848-49d7-4551-9d05-f6dd9bd2a0cd",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        voltageStationMainLeftA: "errorPowerMainLeftVoltageCurrent",
        voltageStationMainLeftB: "errorPowerMainLeftVoltageCurrent",
        voltageStationMainLeftC: "errorPowerMainLeftVoltageCurrent",
        currentStationMainLeftA: "errorPowerMainLeftVoltageCurrent",
        currentStationMainLeftB: "errorPowerMainLeftVoltageCurrent",
        currentStationMainLeftC: "errorPowerMainLeftVoltageCurrent",
        // powerStationMainLeftA: "errorPowerMainLeft",
        // powerStationMainLeftB: "errorPowerMainLeft",
        // powerStationMainLeftC: "errorPowerMainLeft",
        powerStationMainLeftTotal: "errorPowerMainLeftPowerEnergy",
        // energyStationMainLeftA: "errorPowerMainLeft",
        // energyStationMainLeftB: "errorPowerMainLeft",
        // energyStationMainLeftC: "errorPowerMainLeft",
        energyStationMainLeftTotal: "errorPowerMainLeftPowerEnergy",
        energyStationMainLeftYesterday: "errorPowerMainLeftPowerEnergy",
        voltageStationBackupLeftA: "errorPowerBackupLeftVoltageCurrent",
        voltageStationBackupLeftB: "errorPowerBackupLeftVoltageCurrent",
        voltageStationBackupLeftC: "errorPowerBackupLeftVoltageCurrent",
        currentStationBackupLeftA: "errorPowerBackupLeftVoltageCurrent",
        currentStationBackupLeftB: "errorPowerBackupLeftVoltageCurrent",
        currentStationBackupLeftC: "errorPowerBackupLeftVoltageCurrent",
        // powerStationBackupLeftA: "errorPowerBackupLeft",
        // powerStationBackupLeftB: "errorPowerBackupLeft",
        // powerStationBackupLeftC: "errorPowerBackupLeft",
        powerStationBackupLeftTotal: "errorPowerBackupLeftPowerEnergy",
        // energyStationBackupLeftA: "errorPowerBackupLeft",
        // energyStationBackupLeftB: "errorPowerBackupLeft",
        // energyStationBackupLeftC: "errorPowerBackupLeft",
        energyStationBackupLeftTotal: "errorPowerBackupLeftPowerEnergy",
        energyStationBackupLeftYesterday: "errorPowerBackupLeftPowerEnergy",

        voltageStationMainRightA: "errorPowerMainRightVoltageCurrent",
        voltageStationMainRightB: "errorPowerMainRightVoltageCurrent",
        voltageStationMainRightC: "errorPowerMainRightVoltageCurrent",
        currentStationMainRightA: "errorPowerMainRightVoltageCurrent",
        currentStationMainRightB: "errorPowerMainRightVoltageCurrent",
        currentStationMainRightC: "errorPowerMainRightVoltageCurrent",
        // powerStationMainRightA: "errorPowerMainRight",
        // powerStationMainRightB: "errorPowerMainRight",
        // powerStationMainRightC: "errorPowerMainRight",
        powerStationMainRightTotal: "errorPowerMainRightPowerEnergy",
        // energyStationMainRightA: "errorPowerMainRight",
        // energyStationMainRightB: "errorPowerMainRight",
        // energyStationMainRightC: "errorPowerMainRight",
        energyStationMainRightTotal: "errorPowerMainRightPowerEnergy",
        energyStationMainRightYesterday: "errorPowerMainRightPowerEnergy",
        voltageStationBackupRightA: "errorPowerBackupRightVoltageCurrent",
        voltageStationBackupRightB: "errorPowerBackupRightVoltageCurrent",
        voltageStationBackupRightC: "errorPowerBackupRightVoltageCurrent",
        currentStationBackupRightA: "errorPowerBackupRightVoltageCurrent",
        currentStationBackupRightB: "errorPowerBackupRightVoltageCurrent",
        currentStationBackupRightC: "errorPowerBackupRightVoltageCurrent",
        // powerStationBackupRightA: "errorPowerBackupRight",
        // powerStationBackupRightB: "errorPowerBackupRight",
        // powerStationBackupRightC: "errorPowerBackupRight",
        powerStationBackupRightTotal: "errorPowerBackupRightPowerEnergy",
        // energyStationBackupRightA: "errorPowerBackupRight",
        // energyStationBackupRightB: "errorPowerBackupRight",
        // energyStationBackupRightC: "errorPowerBackupRight",
        energyStationBackupRightTotal: "errorPowerBackupRightPowerEnergy",
        energyStationBackupRightYesterday: "errorPowerBackupRightPowerEnergy",

        humidityDehumidifierLeft: "errorDehumidifierLeft",
        temperatureDehumidifierLeft: "errorDehumidifierLeft",
        humidityDehumidifierRight: "errorDehumidifierRight",
        temperatureDehumidifierRight: "errorDehumidifierRight",
        humidityDehumidifierEquivalentLeft: "errorDehumidifierLeft",
        humidityDehumidifierEquivalentRight: "errorDehumidifierRight",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierLeft: "errorDehumidifierLeft",
        malfunctionDehumidifierRight: "errorDehumidifierRight",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityDehumidifierLeft: "humidityTooltipErrorDehumidifierLeft",
        humidityDehumidifierRight: "humidityTooltipErrorDehumidifierRight",
        humidityDehumidifierEquivalentLeft: "humidityTooltipErrorDehumidifierEquivalentLeft",
        humidityDehumidifierEquivalentRight: "humidityTooltipErrorDehumidifierEquivalentRight",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierLeft: "runningClassLeft",
        runningDehumidifierRight: "runningClassRight",
      },

      //station id list
      stationIdList: [
        "fa5d580f-1b3f-499f-9ac6-06663a4d93c8",
        "5ef6bc9c-078f-48fd-bfa3-417b40cda9da",
        "4ade1b4b-0eda-459a-88db-95cdf09387ff",
        "9658719c-40d9-4c73-bc71-f0fe706733f9",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
    toNumber(val) {
      if (val === 0) return "0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(0);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );

      this.getEnergyConsumeYesterday();
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    getEnergyConsumeYesterday() {
      this.getEnergyConsumeYesterdayByDevice("913bb46d-64e8-48cf-8516-5c27b3199623", "energyStationMainLeftYesterday", "errorPowerMainLeftPowerEnergy");
      this.getEnergyConsumeYesterdayByDevice(
        "b092fdee-f9f8-426d-8588-0dcf8a4d12a1",
        "energyStationBackupLeftYesterday",
        "errorPowerBackupLeftPowerEnergy"
      );

      this.getEnergyConsumeYesterdayByDevice("17b49f13-82e2-4866-a4f1-af5740b9bea2", "energyStationMainRightYesterday", "errorPowerMainRightPowerEnergy");
      this.getEnergyConsumeYesterdayByDevice(
        "02108d32-1e6e-4cd1-95a2-b04af25d2639",
        "energyStationBackupRightYesterday",
        "errorPowerBackupRightPowerEnergy"
      );
    },
    getEnergyConsumeYesterdayByDevice(deviceId, dataName, errorName) {
      this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_DAY&count=2&insertBlankData=true").then((resData) => {
        let targetData = resData.data.dataList[0];
        if (targetData) {
          this[dataName] = targetData.value;
          this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], targetData.errorLevel);
        }
      });
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag, dehumidifierName) {
      let result = "";
      if (name) {
        result += name + ": ";
      }
      if (!dehumidifierName || dehumidifierName === "") {
        dehumidifierName = "除湿机";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", " + dehumidifierName + "运行";
        } else if (runningFlag === 0) {
          result += ", " + dehumidifierName + "停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    assembleTooltip_groupKeyValue(name, keyList, valueList, unitList) {
      let result = "";
      if (name) {
        result += name + "\u00A0\u00A0\u00A0\u00A0";
      }

      for (let i = 0; i < keyList.length; i++) {
        let key = keyList[i];
        let value = valueList[i];
        let unit = unitList[i];

        if (i !== 0) {
          result += " ";
        }
        result += key + ": ";

        if (value === "--" || value === null || value === undefined || isNaN(Number(value))) {
          result += "数据中断";
        } else {
          result += Number(value).toFixed(1);
          if (unit) {
            result += unit;
          }
        }
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
    hrefToStation(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + id);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 48px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 94%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 35px;
            left: -35px;
            width: 95px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -73px;
            top: -110px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 35px;
            left: -35px;
            width: 95px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -73px;
            top: -110px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-power-left-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 10px;
            left: -12px;
            width: 40px;
            transform: rotate(75deg);
          }
          &::after {
            bottom: 29px;
            left: -17px;
            width: 20px;
          }
          .state-info {
            right: 15px;
            top: -30px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 180px;
          }
        }

        .sta-power-left-right {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 10px;
            left: -2px;
            width: 40px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 29px;
            left: 23px;
            width: 20px;
          }
          .state-info {
            right: -269px;
            top: -30px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 230px;
          }
        }

        .sta-power-right-left {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 10px;
            left: -12px;
            width: 40px;
            transform: rotate(75deg);
          }
          &::after {
            bottom: 29px;
            left: -17px;
            width: 20px;
          }
          .state-info {
            right: 15px;
            top: -30px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 230px;
          }
        }

        .sta-power-right-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 10px;
            left: -2px;
            width: 40px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 29px;
            left: 23px;
            width: 20px;
          }
          .state-info {
            right: -220px;
            top: -30px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 180px;
          }
        }
      }
    }
  }
}
</style>
